// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ColumnsSvg from '@rsuite/icon-font/lib/layout/Columns';
var Columns = createSvgIcon({
  as: ColumnsSvg,
  ariaLabel: 'columns',
  category: 'layout',
  displayName: 'Columns'
});
export default Columns;